import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EvenementsService from '../../services/evenementsService';

const initialState = {
  Evenements: [],
  EvenementId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements:0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

export const createEvenement = createAsyncThunk(
  'Evenement/create',
  async (data, thunkAPI) => {
    try {
      return await EvenementsService.createEvenement(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllEvenement = createAsyncThunk(
  'Evenement/getAll',
  async (_, thunkAPI) => {
    try {
      return await EvenementsService.getAllEvenement();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateEvenement = createAsyncThunk(
  'Evenement/update',
  async ({id,data}, thunkAPI) => {
    try {
      // const token = thunkAPI.getState().auth.user.token;
      return await EvenementsService.updateEvenement(id,data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateThumbnailEvent = createAsyncThunk(
  'Evenement/update_thumbnail',
  async ({id,data}, thunkAPI) => {
    try {
      // const token = thunkAPI.getState().auth.user.token;
      return await EvenementsService.updateThumbnail(id,data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getEvenementById = createAsyncThunk(
  'Evenement/id',
  async (id, thunkAPI) => {
    try {
      return await EvenementsService.getEvenementById(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      console.log(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DeleteEvenement = createAsyncThunk(
  'Evenement/delete',
  async (id, thunkAPI) => {
    try {
      return await EvenementsService.DeleteEvenement(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const EvenementSlice = createSlice({
  name: 'evenements',
  initialState,
  reducers: {
    clearEvent: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(createEvenement.pending, state => {
        state.isLoading = true;
      })
      .addCase(createEvenement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const created = action.payload?.result || action.payload?.data || action.payload;
        if (created) {
          state.Evenements.unshift(created);
        }
      })
      .addCase(createEvenement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllEvenement.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllEvenement.fulfilled, (state, action) => {
        state.isLoading = false;
        const payload = action.payload?.result || action.payload?.data || action.payload;
        const items = Array.isArray(payload) ? payload : payload?.items || payload?.data || [];
        state.Evenements = items;
        const pagination = action.payload?.pagination || {};
        state.currentPage = pagination.current_page || 1;
        state.pageSize = pagination.limit || items.length || 20;
        state.totalElements = pagination.total_items || items.length || 0;
      })
      .addCase(getAllEvenement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateEvenement.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateEvenement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // state.region = action.payload;
      })
      .addCase(updateEvenement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateThumbnailEvent.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateThumbnailEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // state.region = action.payload;
      })
      .addCase(updateThumbnailEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getEvenementById.pending, state => {
        state.isLoading = true;
      })
      .addCase(getEvenementById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.EvenementId = action.payload?.result || action.payload?.data || action.payload;
      })
      .addCase(getEvenementById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(DeleteEvenement.pending, state => {
        state.isLoading = true;
      })
      .addCase(DeleteEvenement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Evenements = state.Evenements.filter(
          goal => goal.id !== action.payload.data
        );
      })
      .addCase(DeleteEvenement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { clearEvent } = EvenementSlice.actions;
export default EvenementSlice.reducer;
